import {Injectable} from '@angular/core';
import {Enrollment} from '../models/enrollment';
import {FormBuilder} from '@angular/forms';
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class EnrollmentService {

  constructor (
    private fb: FormBuilder,
    private fs: AngularFireStorage,
    private db: AngularFirestore,
    private snackBar: SnackBarIconService
  ) { }

  _selectByEvent (event_id) {
    return this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
      .where('event_id', '==', event_id))
      .snapshotChanges();
  }


  async select (): Promise<any[]> {
    const array: any[] = [];
    try {
      const querySnapshot = await this.db.collection<Enrollment>('sbccv_enrollment')
        .get()
        .toPromise();

      querySnapshot.forEach(doc => {
        // console.log("doc.id: " + doc.id)
        const data: any = {
          "id": doc.id,
          ...doc.data()
        }
        array.push(data);
      });

    } catch (error) {
      console.error("Erro ao buscar enrollments");
    }

    return array;
  }

  async selectByEvent (event_id: string): Promise<any[]> {
    // console.log("getProductsByEvents: " + JSON.stringify(events))
    const array: any[] = [];
    try {
      const querySnapshot = await this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
        .where('event_id', '==', event_id))
        .get()
        .toPromise();

      querySnapshot.forEach(doc => {
        // console.log("doc.id: " + doc.id)
        const data: any = {
          "id": doc.id,
          ...doc.data()
        }
        array.push(data);
      });

    } catch (error) {
      console.error(`Erro ao buscar enrollment para o evento ${ event_id }:`, error);
    }

    return array;
  }

    async selectByOneEvent (event_id: string): Promise<any[]> {
      const querySnapshot = await firstValueFrom(
        this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
          .where('event_id', '==', event_id)).get()
      );
  
      return querySnapshot.docs.map(doc => ({
         ...doc.data(),
        id: doc.id
      }));
    }

  async selectByEvents (events: string[]): Promise<any[]> {
    // console.log("getProductsByEvents: " + JSON.stringify(events))
    const array: any[] = [];

    for (const event_id of events) {
      try {
        const querySnapshot = await this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
          .where('event_id', '==', event_id))
          .get()
          .toPromise();

        querySnapshot.forEach(doc => {
          // console.log("doc.id: " + doc.id)
          const data: any = {
            "id": doc.id,
            ...doc.data()
          }
          array.push(data);
        });

      } catch (error) {
        console.error(`Erro ao buscar agenda para o evento ${ event_id }:`, error);
      }
    }
    return array;
  }

  selectByMember (member_id) {
    return this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
      .where('member_id', '==', member_id)
      .orderBy('created', 'desc')).snapshotChanges();
  }

  exist (event_id, member_id) {
    return this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
      .where('event_id', '==', event_id)
      .where('member_id', '==', member_id)).get();
  }

  existAsUser (event_id, member_id) {
    return this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
      .where('type', '==', 'participante')
      .where('event_id', '==', event_id)
      .where('member_id', '==', member_id)).get();
  }

  existStaff (item) {
    if (item.topic_id) {
      return this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
        .where('event_id', '==', item.event_id)
        .where('day_id', '==', item.day_id)
        .where('activity_id', '==', item.activity_id)
        .where('topic_id', '==', item.topic_id)
        .where('member_id', '==', item.member_id)).get();
    } else {
      return this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
        .where('event_id', '==', item.event_id)
        .where('day_id', '==', item.day_id)
        .where('activity_id', '==', item.activity_id)
        .where('member_id', '==', item.member_id)).get();
    }

  }

  async insert (entity: Enrollment) {
    // delete entity.id;
    return this.db.collection('sbccv_enrollment').add(Object.assign({}, entity));
  }

  async remove (enrollment_id: any) {
    return this.db.collection('sbccv_enrollment').doc(enrollment_id).delete()
  }

  update (id: any) {
    return this.db.collection('sbccv_enrollment')
      .doc(id)
      .update({"finished": true});
  }

}
